
import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { Quote, ThumbsUp } from "lucide-react";
import { motion } from "framer-motion";

interface TestimonialsProps {
  className?: string;
}

export function Testimonials({ className }: TestimonialsProps) {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  
  const testimonials = [
    {
      quote: "Grazie a Gildy ho trovato un compro oro che mi ha offerto 200€ in più rispetto alla prima valutazione ricevuta.",
      author: "Marco R.",
      role: "Cliente",
      location: "Roma Centro"
    },
    {
      quote: "L'app è fantastica per monitorare i prezzi. L'ho usata per vendere dei vecchi gioielli nel momento migliore.",
      author: "Giulia T.",
      role: "Cliente",
      location: "EUR"
    },
    {
      quote: "Come titolare di un compro oro, Gildy mi ha aiutato ad aumentare la clientela e la trasparenza del mio business.",
      author: "Roberto M.",
      role: "Compro Oro Partner",
      location: "Trastevere"
    }
  ];

  return (
    <div className={cn("space-y-6", className)}>
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold mb-2 metal-text tracking-tight">Cosa Dicono i Nostri Utenti</h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">Esperienze reali di chi ha già utilizzato i nostri servizi per ottenere il massimo valore dai propri preziosi</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {testimonials.map((testimonial, index) => (
          <motion.div 
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2, duration: 0.5 }}
            whileHover={{ scale: 1.03 }}
          >
            <Card 
              className={cn(
                "h-full border-metal-light/20 transition-all duration-300",
                activeIndex === index ? "border-metal shadow-lg" : "hover:border-metal/60 hover:shadow-md"
              )}
              onMouseEnter={() => setActiveIndex(index)}
              onMouseLeave={() => setActiveIndex(null)}
            >
              <CardContent className="pt-6 h-full flex flex-col">
                <div className="mb-4 flex justify-between items-start">
                  <Quote className="h-8 w-8 text-metal opacity-50" />
                  {activeIndex === index && (
                    <motion.div 
                      initial={{ scale: 0 }}
                      animate={{ scale: 1 }}
                      className="bg-metal/10 p-1.5 rounded-full"
                    >
                      <ThumbsUp className="h-4 w-4 text-metal" />
                    </motion.div>
                  )}
                </div>
                <p className="mb-6 text-muted-foreground italic flex-grow">"{testimonial.quote}"</p>
                <div className="border-t pt-4 mt-auto">
                  <div className="flex justify-between items-end">
                    <div>
                      <p className="font-semibold metal-text">{testimonial.author}</p>
                      <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                    </div>
                    <div className="text-right">
                      <span className="text-xs font-medium bg-metal/10 px-2 py-1 rounded-full">
                        {testimonial.location}
                      </span>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
